import { AutogenModelEdilocation, AutogenRowEdilocation } from "./autogen/AutogenModelEdilocation";

export class ModelEdilocation extends AutogenModelEdilocation<RowEdilocation> {
    constructor() {
        super(RowEdilocation);
    }
}

export class RowEdilocation extends AutogenRowEdilocation {
}